module.exports = __webpack_public_path__ + "img/picto-petit-cochon-moins.f31b18b2.svg";